<template>
	<div>
		<div class="poll-none">
			<div class="box-poll">
				<div class="topic">
					{{ topic }}
				</div>

				<template v-for="choice in poll.choices">
					<div class="choice dash-bg-color-skin-light-50">
						<div :class="'progress' + choice.progress" class="dash-bg-color-skin-light-10">	
						</div>

						<div class="choosentext"> 				
							<i>&nbsp;</i>
							<div class="text">&nbsp;</div>
							<div class="number">&nbsp;</div>
						</div>
					</div>
				</template>		

				<div class="clearfix"></div>

				<div class="date-box">
					<div class="date-poll dash-color-skin">00/00/0000 - 00/00/0000</div>
					<i class="fa fa-clock-o dash-color-skin" aria-hidden="true"></i>
				</div>

				<div class="penguin">
					<img src="~static/poll/penguin.png">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
const dataPoll = {
  choices: [{
    progress: '1'
  }, {
    progress: '2'
  }, {
    progress: '3'
  }]
}

export default {
  name: 'poll-none',
  data () {
    return {
      pollHead: 'Survey Form',
      topic: 'Do not have survey form at present',
      poll: dataPoll
    }
  }
}
</script>


// WEBPACK FOOTER //
// none.vue?395e9328